import EnumClass, { build } from '../EnumClass';
import data, { ServiceId, ServiceData } from './data';
import * as Translations from './translations';

export class Service extends EnumClass<ServiceId, ServiceData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: SERVICES,
  getById: getServiceById,
  marshaller: ServiceMarshaller,
  isId: isServiceId,
} = build<ServiceId, ServiceData, Service>('ServiceEnum', data, Service);
